import { useState } from "react";
import { Col, Row } from "./Flexbox";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { Circle } from "@mui/icons-material";
import Text from "./Text";
import TextContainer from "./TextContainer";

const ForecastTable = props => {
    const [hoveredCol, setHoveredCol] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [currentColumn, setCurrentColumn] = useState(null);

    const [popupCoords, setPopupCoords] = useState({x: 0, y: 0});

    const handleRename = (oldName, newName) => {

        if (newName === null) {
            setCurrentColumn("");   //Clean the state in case the user cancels!
            return;
        }

        if(newName === oldName) {
            return;
        }

        props.renameColumn(oldName, newName);

        setCurrentColumn("");
    };

    const isColumnValid = (colName, colIdx) => {
        return props.validColumns.includes(colName)
            || props.predictedIdColumn.name === colName
            || props.predictedMonthColumns.names.includes(colName)
            || props.predictedWeekColumns.names.includes(colName)
            || props.predictedIdColumn.index === colIdx
            || props.predictedMonthColumns.indexes.includes(colIdx);
    };

    const isDark = props.theme.White !== '#FFFFFF';

    const handleMouseEnter = (col, event) => {
        setHoveredCol(col);
        setShowPopup(true);
        setCurrentColumn(col);

        const rect = event.currentTarget.getBoundingClientRect();
        setPopupCoords({
            x: rect.left, y: rect.bottom
        });
    }

    const columns = Array.from(props.table[0].keys());

    return (
        <Col style={{ overflowX: 'auto', overflowY: 'auto', border: `1px solid ${props.theme.Ey}`}}>
             {/* Using vw and vh helps with responsiveness (If this goes over 65 in vw, the table will start pushing the Forecast list in small screens)*/}
            <div style={{maxWidth: '65vw', maxHeight: '70vh'}}>
                <table style={{ borderCollapse: 'collapse', width: 'auto' }}>
                    <thead>
                        <tr>
                            <th 
                                onClick={() => props.deleteHeaderRow()} 
                                style={{ cursor: 'pointer', paddingRight: '10px' }}><RemoveCircleIcon style={{color:props.theme.Red, fontSize: 20, cursor:'pointer'}}/></th>
                            {columns.map((col, colIdx) => (
                                <th
                                    key={col}
                                    onMouseEnter={(e) => {
                                        handleMouseEnter(col, e);
                                    }}
                                    onMouseLeave={() => setShowPopup(false)}
                                    style={{
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 1,
                                        border: '1px solid #ccc',
                                        padding: '6px',
                                        background:
                                            props.predictedIdColumn.name === col
                                                ? props.theme.Lime
                                                : props.predictedMonthColumns.offsets?.[col] > 0 
                                                ? props.theme.Brown
                                                : props.predictedWeekColumns.offsets?.[col] > 0
                                                ? props.theme.Teal
                                                : props.predictedMonthColumns.names.includes(col)
                                                ? props.theme.Yellow
                                                : isColumnValid(col, colIdx) || props.predictedWeekColumns.names.includes(col)
                                                ? props.theme.Blue
                                                : props.theme.White,
                                        color: isColumnValid(col, colIdx) || props.predictedIdColumn.name === col || props.predictedMonthColumns.names.includes(col) || props.predictedWeekColumns.names.includes(col) ? undefined : (isDark ? props.theme.Black : undefined),
                                        cursor: 'pointer'
                                    }}
                                >
                                    {col}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {props.table.map((row, rowIdx) => (
                            <tr key={rowIdx}>
                                <td onClick={() => props.deleteRow(rowIdx)} style={{ cursor: 'pointer', paddingRight: '10px' }}><RemoveCircleIcon style={{color:props.theme.Red, fontSize: 20, cursor:'pointer'}}/></td>
                                {Array.from(row.values()).map((val, colIdx) => {
                                    const cellBackground =
                                        props.predictedIdColumn.index === colIdx
                                        ? `rgba(${parseInt(props.theme.Lime.slice(1, 3), 16)}, ${parseInt(props.theme.Lime.slice(3, 5), 16)}, ${parseInt(props.theme.Lime.slice(5, 7), 16)}, 0.5)`
                                        : props.predictedMonthColumns.offsets?.[columns[colIdx]] > 0
                                        ? `rgba(${parseInt(props.theme.Brown.slice(1, 3), 16)}, ${parseInt(props.theme.Brown.slice(3, 5), 16)}, ${parseInt(props.theme.Brown.slice(5, 7), 16)}, 0.3)`
                                        : props.predictedWeekColumns.offsets?.[columns[colIdx]] > 0
                                        ? `rgba(${parseInt(props.theme.Teal.slice(1, 3), 16)}, ${parseInt(props.theme.Teal.slice(3, 5), 16)}, ${parseInt(props.theme.Teal.slice(5, 7), 16)}, 0.3)`
                                        : props.predictedMonthColumns.indexes.includes(colIdx)
                                        ? `rgba(${parseInt(props.theme.Yellow.slice(1, 3), 16)}, ${parseInt(props.theme.Yellow.slice(3, 5), 16)}, ${parseInt(props.theme.Yellow.slice(5, 7), 16)}, 0.5)`
                                        : props.predictedWeekColumns.indexes.includes(colIdx)
                                        ? `rgba(${parseInt(props.theme.Blue.slice(1, 3), 16)}, ${parseInt(props.theme.Blue.slice(3, 5), 16)}, ${parseInt(props.theme.Blue.slice(5, 7), 16)}, 0.5)`
                                        : props.validColumns.includes(columns[colIdx])
                                        ? `rgba(${parseInt(props.theme.Blue.slice(1, 3), 16)}, ${parseInt(props.theme.Blue.slice(3, 5), 16)}, ${parseInt(props.theme.Blue.slice(5, 7), 16)}, 0.3)`
                                        : '';
                                    return (
                                        <td
                                            key={columns[colIdx]}
                                            style={{
                                                border: '1px solid #ccc',
                                                padding: '6px',
                                                background: cellBackground,
                                                color: !cellBackground && isDark ? props.theme.Black : undefined,
                                            }}
                                        >
                                            {val ?? ''}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {showPopup && hoveredCol && (
                <div style={{
                    position: 'fixed',
                    top: popupCoords.y,
                    left: popupCoords.x,
                    zIndex: 1000,
                    background: props.theme.Checo,
                    border: `1px solid ${props.theme.Ey}`,
                    padding: '4px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    width: '264px',
                    height: '350px',
                }} onMouseEnter={() => setShowPopup(true)} onMouseLeave={() => {setShowPopup(false); if (currentColumn && currentColumn !== null) {
                    handleRename(hoveredCol, currentColumn);}
                }}>
                    <Col style={{gap: '8px', alignItems:'start', margin: '12px'}}>
                        <Text color={props.theme.ONED}>Verifica el formato del título:</Text>
                        <TextContainer theme={props.theme} value={currentColumn !== null ? currentColumn : hoveredCol} onChange={(text) => setCurrentColumn(text)} style={{width: '232px', height: '36px'}}></TextContainer>
                        {props.message[hoveredCol] && (
                            <Text color={props.message[hoveredCol].isValid ? props.theme.Verde : props.theme.Red}style={{position: 'relative', alignItems:'start'}}>{props.message[hoveredCol].message}</Text>
                        )}
                    </Col>
                    <Col style={{gap: '8px', alignItems: 'start', margin: '12px'}}>
                        <Text color={props.theme.ONED}>Clasifica esta columna: </Text>
                        <Row onClick={() => props.overwrite(hoveredCol, 'id')}><Circle style={{color: props.theme.Lime, cursor: 'pointer', fontSize: 'large', marginRight: '6px'}}/> <Text color={props.theme.SEVENB}>Numero de parte</Text></Row>
                        <Row onClick={() => props.overwrite(hoveredCol, 'month', 0)}><Circle style={{color: props.theme.Orange, cursor: 'pointer', fontSize: 'large', marginRight: '6px'}}/> <Text color={props.theme.SEVENB}>Mes de este año</Text></Row>
                        <Row onClick={() => props.overwrite(hoveredCol, 'month', 1)}><Circle style={{color: props.theme.Brown, cursor: 'pointer', fontSize: 'large', marginRight: '6px'}}/> <Text color={props.theme.SEVENB}>Mes del próximo año</Text></Row>
                        <Row onClick={() => props.overwrite(hoveredCol, 'week', 0)}><Circle style={{color: props.theme.Blue, cursor: 'pointer', fontSize: 'large', marginRight: '6px'}}/> <Text color={props.theme.SEVENB}>Semana de este año</Text></Row>
                        <Row onClick={() => props.overwrite(hoveredCol, 'week', 1)}><Circle style={{color: props.theme.Teal, cursor: 'pointer', fontSize: 'large', marginRight: '6px'}}/> <Text color={props.theme.SEVENB}>Semana del próximo año</Text></Row>
                        <Row onClick={() => props.deselect(hoveredCol)}><Circle style={{color: props.theme.Coco, cursor: 'pointer', fontSize: 'large', marginRight: '6px'}}/> <Text color={props.theme.SEVENB}>Deseleccionar</Text></Row>
                        <Row onClick={() => props.deleteColumn(hoveredCol)}><Circle style={{color: props.theme.Red, textColor: props.theme.SEVENB, cursor: 'pointer', fontSize: 'large', marginRight: '6px'}}/> <Text color={props.theme.SEVENB}>Eliminar columna</Text></Row>
                    </Col>
                </div>
            )}
        </Col>
    );
};

export default ForecastTable;
